/**
 * A module for periodically checking the project's from template creation status
 * Status is currently introduced via the model TemplateCreationJob that holds the data
 * needed for the background job Templates::AttachButtonImages
 * which is responsible for creating, storing and attaching button images to the choices
 * that were created via template
 * @module lib/check_project_creation
 */
const PATH_ATTRIBUTE = 'data-check-project-creation';

export default function checkProjectCreation() {
  let interval;

  // Expose the function to `window` so that the backend can call it
  window.setUpProjectCreationCheck = function () {
    const element = document.querySelector(`[${PATH_ATTRIBUTE}]`);

    if (element) {
      interval = setInterval(() => {
        $.get(element.getAttribute(PATH_ATTRIBUTE), (response) => {
          if (response.completed === true) {
            // Enable button and update its copy
            const button = document.getElementById('js-project-ready-button');
            button.innerHTML = 'Go to project';
            button.classList.remove('disabled');
            button.classList.add('text-white');

            // Show flash message (success)
            const flashMessage = document.getElementById('js-project-ready-flash');
            flashMessage.classList.remove('d-none');

            // Remove overlay on button click
            $(document).on('click', button, function () {
              element.classList.add('d-none');
            });

            // Stop listening to the project creation progress
            clearInterval(interval);
          }
        });
      }, 1000);
    }
  };

  $(document).on('turbolinks:before-cache', () => {
    clearInterval(interval);
  });
}
